import React from 'react'
import isFunction from 'lodash/isFunction'
import { useModalState } from 'src/Modal/ModalStateContext'
import {
  StandardButtonSize,
  StandardButtonVariant,
} from '../Reusable/Buttons/StandardButton'
import { ModalFormId } from './ModalForm'
import {
  ModalButton,
  StyledModalButton,
  StyledToggleDiv,
} from './ModalForm.styles'

type StandardOpenModalButtonProps = {
  modalId: ModalFormId
  text: string
  variant: StandardButtonVariant
  size: StandardButtonSize
  isHidden: boolean
  isDisabled: boolean
  onClick?: () => void
  children?: React.ReactNode
  testId?: string
}

export const StandardOpenModalButton = ({
  modalId,
  text,
  variant,
  size,
  isHidden,
  isDisabled,
  onClick,
  children,
  testId,
}: StandardOpenModalButtonProps): JSX.Element => {
  const { openModal } = useModalState()
  const onClickFunction = (e: React.MouseEvent) => {
    e.preventDefault()
    isFunction(onClick) && onClick()
    openModal(modalId)
  }

  return (
    <StyledModalButton
      type="button"
      variant={variant}
      buttonSize={size}
      hidden={isHidden}
      disabled={isDisabled}
      onClick={onClickFunction}
      data-testid={testId}
    >
      {children || text}
    </StyledModalButton>
  )
}

StandardOpenModalButton.defaultProps = {
  text: 'Continue',
  variant: StandardButtonVariant.PRIMARY,
  size: StandardButtonSize.MEDIUM,
  isHidden: false,
  isDisabled: false,
}

type LargeOpenModalButtonProps = {
  modalId: ModalFormId
  children: React.ReactNode
  onClick?: () => void
  testId?: string
}

export const LargeOpenModalButton = ({
  modalId,
  children,
  onClick,
  testId,
}: LargeOpenModalButtonProps): JSX.Element => {
  const { openModal } = useModalState()
  const onClickFunction = (e: React.MouseEvent) => {
    e.preventDefault()
    isFunction(onClick) && onClick()
    openModal(modalId)
  }

  return (
    <ModalButton data-testid={testId} onClick={onClickFunction}>
      {children}
    </ModalButton>
  )
}

type OpenModalWrapperProps = {
  modalFormId: ModalFormId
  children: React.ReactNode
  onClick?: () => void
}

export const OpenModalWrapper = ({
  modalFormId,
  children,
  onClick,
}: OpenModalWrapperProps): JSX.Element => {
  const { openModal } = useModalState()

  const onClickFunction = (e: React.MouseEvent) => {
    e.preventDefault()
    isFunction(onClick) && onClick()
    openModal(modalFormId)
  }
  return <StyledToggleDiv onClick={onClickFunction}>{children}</StyledToggleDiv>
}
